import { z } from "zod";
import { displayRegistry } from "./display-registry";

export * from "./display-registry";

// Generate Zod Schemas dynamically from the registry to ensure they stay in sync
export function getSectionDisplayOptionsSchema(sectionType: keyof typeof displayRegistry) {
  const registry = displayRegistry[sectionType];
  if (!registry) {
    return z.object({
      version: z.literal(1).optional(),
      presentation: z.string().optional(),
      emphasis: z.string().optional(),
    }).strict();
  }

  const presentations = registry.presentations.map(p => p.id) as [string, ...string[]];
  const emphases = registry.emphases.map(e => e.id) as [string, ...string[]];

  return z.object({
    version: z.literal(1).optional(),
    presentation: z.enum(presentations).optional(),
    emphasis: z.enum(emphases).optional(),
  }).strict();
}
